import { render, staticRenderFns } from "./ContractPhaseDisplay.vue?vue&type=template&id=42680f91&"
import script from "./ContractPhaseDisplay.vue?vue&type=script&lang=ts&"
export * from "./ContractPhaseDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports